module.exports = __webpack_public_path__ + "img/tcby-qr-code.9c2e20b7.webp";